var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.42222C0 0.636751 0.628372 0 1.40351 0H6.18914C6.60315 0 6.99603 0.18522 7.2627 0.506118L7.72853 1.06667L9.22853 2.87166C9.4952 3.19256 9.88808 3.37778 10.3021 3.37778H20V14.5778C20 15.3632 19.3716 16 18.5965 16H1.40351C0.628372 16 0 15.3632 0 14.5778V1.42222Z",
    fill: "#FFA721"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3021 3.37778H20V2.13333C20 1.54423 19.5287 1.06667 18.9474 1.06667H7.72853L9.22853 2.87166C9.4952 3.19256 9.88808 3.37778 10.3021 3.37778Z",
    fill: "#D38105"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.19c0de7836964aef6a2446e9e1af4267.svg";
export { ForwardRef as ReactComponent };